/**
 * The color palette of the website
 */
export const Colors = {
  SkyBlue: "#37AACE",
  Wisteria: "#C490D1",
  DarkWisteria: "#74577B",
  DarkerWisteria: "#5F4A64",
  DarkestWisteria: "#332836",
  MediumWisteria: "#8e6b96",
  Cobalt: "#344765",
  VeryLightCobalt: "#719ad9",
  LightCobalt: "#4a6691",
  DarkCobalt: "#1c2636",
  CherryPink: "#FFC2F0",
  DarkGrey: "#A1A1A1",
  LightGrey: "#CFCFCF",
  White: "#FFFFFF",
  CoalBlue: "#2E3144",
  VeryDarkBlue: "#141316",
  NearlyBlack: "#0e0e13"
}